import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';

function WriteReview({
  getData, baseURL, templateid, contactid, 
}) {
  const navigate = useNavigate();

  const [experienceData, setExperienceData] = useState('');
  const [willingContacted, setWillingContacted] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const SendReview = async () => {
    const putbody = {
      experience: experienceData,
      willing_contacted: willingContacted,
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseURL}/testing/contact-us/${templateid}/${contactid}`,
        putbody,
      );
      
      console.log(response, 'SendReview review post');
      if (response.data.status === 'success') {
        //   setData(response?.data?.data);
        navigate(`/reviewus/${templateid}/${contactid}`);

        setLoading(false);
      }
      if (response.data.status === 'failure') {
        //   setData(response?.data?.data);
        // setPage(3);
        setShowError(true);
        setErrorMsg(response.data.message);

        // setLoading(false);
      }
    } catch (error) {
      console.log(error, 'error');
      setShowError(true);
      setErrorMsg(error.response.data.error);
    }
  };

  return (
    <div className="qs-fade-in space-y-6">
      <div className="qs-title">
        <p>{getData.template.feedback_page_message}</p>
      </div>
      <div>
        <textarea
          className="qs-input min-h-[160px] resize-y"
          placeholder="Tell us about your experience"
          value={experienceData}
          onChange={(e) => setExperienceData(e.target.value)}
        />
      </div>

      <div>
        {getData.template?.feedback_callback_requestion_flag && (
          <FormControlLabel
            sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'inherit', fontSize: '14px', color: '#475569' } }}
            control={(
              <Checkbox
                checked={willingContacted}
                onChange={(e) => setWillingContacted(e.target.checked)}
              />
                )}
            label={getData.template.feed_back_callback_message}
          />
        )}            
      </div>

      {showError ? (
        <p className="show-error rounded-xl border border-red-200 !bg-red-50 px-4 py-3 text-sm !text-red-700 !max-w-full">
          {errorMsg}
        </p>
      ) : null}

      <div className="flex justify-center">
        <button
          type="button"
          disabled={experienceData?.length < 4 || loading}
          className="qs-btn qs-btn-primary disabled:!bg-slate-300 disabled:!text-slate-500"
          onClick={SendReview}
        >
          Submit
        </button>
      </div>

    </div>
  );
}

export default WriteReview;
